import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "prefix"> {
  invalid?: boolean;
  align?: "left" | "right";
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, align = "left", prefix, suffix, ...rest },
  ref,
) {
  if (prefix || suffix) {
    return (
      <div
        className={cn(
          "flex items-stretch h-11 sm:h-9 w-full rounded-md border bg-white overflow-hidden",
          "border-border-strong",
          "focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-0 focus-within:border-accent-500",
          invalid && "border-danger-700 focus-within:ring-danger-700",
          className,
        )}
      >
        {prefix && (
          <span className="flex items-center pl-3 pr-2 text-neutral-500 text-sm border-r border-border">
            {prefix}
          </span>
        )}
        <input
          ref={ref}
          className={cn(
            "flex-1 min-w-0 px-3 bg-transparent text-sm text-foreground placeholder:text-neutral-400",
            "focus:outline-none",
            align === "right" && "text-right tabular",
          )}
          {...rest}
        />
        {suffix && (
          <span className="flex items-center pr-3 pl-2 text-neutral-500 text-sm border-l border-border">
            {suffix}
          </span>
        )}
      </div>
    );
  }
  return (
    <input
      ref={ref}
      className={cn(
        "h-11 sm:h-9 w-full px-3 rounded-md border bg-white text-sm text-foreground placeholder:text-neutral-400",
        "border-border-strong focus:outline-none focus:ring-2 focus:ring-ring focus:border-accent-500",
        invalid && "border-danger-700 focus:ring-danger-700",
        align === "right" && "text-right tabular",
        className,
      )}
      {...rest}
    />
  );
});
